import { reactive } from 'vue'
import { DevicePid } from '@/define/define'
import { DriverService } from './driver/driver'
import { CurrentDevice, ResDeviceState } from '@libs/types/response'
export enum DeviceProtocol {
  none = 0,
  dll_exe = 1,
  hid_web = 2,
}
const DefaultDevice: CurrentDevice = {
  ID: DevicePid.None,
  IsSupportMagnet: false,
  ConnectMode: 0,
  ProductName: '',
  Limit: {
    DpiLen: 0,
    KeysColorLen: 0,
    MacroIndexLen: 0,
    MacroBytesLen: 0,
    MacroPrefix: [],
    KeySetLen: 0,
    MagnetLen: 0,
  },
  IDStr: '',
  IsEEvision: false,
}

const DefaultDeviceStatus: ResDeviceState = {
  ConnectType: 0,
  IsConnect: false,
  IsSleep: false,
}

export class DeviceManager {
  private static _instance: DeviceManager

  public static get instance() {
    return this._instance || (this._instance = new DeviceManager())
  }

  constructor() {}

  state = reactive({
    currentPid: DevicePid.None,
    deviceList: [] as CurrentDevice[], // exe
    webDeviceList: [] as CurrentDevice[], //hid
    currentDevice: { ...DefaultDevice },
    driverServiceVersion: '0',
    driverProtocol: DeviceProtocol.none,
    deviceStatus: { ...DefaultDeviceStatus },
  })

  resetState() {
    this.state.currentPid = DevicePid.None
    this.state.currentDevice = { ...DefaultDevice }
    this.state.deviceStatus = { ...DefaultDeviceStatus }
    this.state.driverProtocol = DeviceProtocol.none
  }

  selectCurrentDevice(pid: DevicePid, mode: DeviceProtocol) {
    this.state.driverProtocol = mode
    DriverService.instance.askToSelect(pid).then(() => {
      DriverService.instance.initializeDevice()
    })
  }

  setCurrentDevice(id: DevicePid) {
    const deviceList = [...this.state.webDeviceList, ...this.state.deviceList]
    const device = deviceList.filter((e) => e.ID == id)
    if (device.length > 0) {
      this.state.currentDevice = device[0]
      this.state.currentPid = device[0].ID
      if (import.meta.env.DEV && this.devOverridePids.includes(this.state.currentPid)) {
        this.state.currentPid = DevicePid.CarotmasMars68Pro_Wireless
      }
    }
  }

  private readonly devOverridePids = [DevicePid.MonsGeek, DevicePid.MonsGeek_NoLight, DevicePid.MonsGeek_NoLight_24g]
}
